import styled from 'styled-components';
import { body1, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p40: pxToRem(40),
};

export const TimeRangeHeader = styled.div`
  ${body1};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.purple100};
  color: ${colors.white};
  border-radius: ${spacing.threeEights};
  padding: ${spacing.base} ${spacing.plusHalf};
  margin-bottom: ${customSpacing.p40};
`;

export const TimeRangeSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
